import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import { Box, TextField } from "@mui/material";
import { API } from "../assets/staticData";
import CategoriesDataTable from "../components/data-tables/CategoriesDataTable";
import SelectLang from "../components/select-lang/SelectLang";
import { createSlug } from "../utils/slug";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
  "Content-Type": "application/json",
};

export default function Categories({ user }) {
  const [error, setError] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState({ category: "", desc: "", slug: "" });
  const [lang, setLang] = useState("");

  useEffect(() => {
    async function getData() {
      fetch(`${API}/categories?populate=*&sort=createdAt:desc`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setPlatforms(respone.data);
      });
    }

    getData();
  }, [refresh]);

  if (error) {
    // Print errors if any
    return <div>An error occured: {error.message}</div>;
  }

  const addItem = () => {
    if (data.category === "" || lang === "" || !data.slug.length) {
      toast("Please fill in all the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
      return;
    }
    fetch(`${API}/categories`, {
      headers,
      method: "POST",
      body: JSON.stringify({
        data: {
          category: data.category,
          desc: data.desc,
          slug: data.slug,
          language: lang,
        },
      }),
    }).then((res) => {
      if (res.ok) {
        setOpenAdd(false);
        setData({ category: "", desc: "" });
        setRefresh(!refresh);
        toast("The Item was successfully added", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    });
  };

  const automateSlug = () => {

    let content = ""
    if (data.slug?.length) {
      content = data.slug.trim()
    } else if (data.category?.length) {
      content = data.category.trim()
    }

    const slug = createSlug(content);

    setData(prevData => ({
      ...prevData,
      slug
    }));
  };

  return (
    <div className="App">
      <div>
        <h3 style={{ textAlign: "start", marginBottom: 10 }}>Categories Settings</h3>

        <Box mt={2}>
          <ClearCacheButton
            keys={[
              CACHE_KEY.startupConfigs,
              CACHE_KEY.articles
            ]} />
        </Box>

        {user.perms[20].add && (
          <div
            className="addC"
            style={{ minHeight: openAdd ? 300 : 50, padding: openAdd ? 20 : 0 }}>
            {openAdd && (
              <div
                className="addContent"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                }}>
                <TextField
                  label="Title"
                  sx={{ width: "50%", mb: 2 }}
                  value={data.category}
                  onChange={(e) => {
                    setData({ ...data, category: e.target.value });
                  }}
                />

                <div className="mt-1 w-1/2  mb-2">
                  <TextField
                    label="Slug"
                    sx={{ width: "100%" }}
                    value={data.slug}
                    onChange={(e) => {
                      setData({ ...data, slug: e.target.value });
                    }}
                  />
                  <div className="mt-1 w-full mr-6 cursor-pointer" onClick={automateSlug}>
                    <p className="text-sm text-right text-sky-700 underline">Automate Slug</p>
                  </div>
                </div>

                <TextField
                  label="Description"
                  sx={{ width: "50%" }}
                  value={data.desc}
                  multiline
                  rows={3}
                  onChange={(e) => {
                    setData({ ...data, desc: e.target.value });
                  }}
                />

                <div style={{ width: "50%", marginTop: 10 }}>
                  <SelectLang lang={lang} setLang={setLang} />
                </div>
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? addItem() : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}>
              Add a new Category
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>

            {openAdd && (
              <div
                onClick={() => {
                  setOpenAdd(false);
                  setData("");
                }}
                className="cancelBTN">
                Cancel
              </div>
            )}
          </div>
        )}

        <CategoriesDataTable
          data={platforms}
          refresh={refresh}
          setRefresh={setRefresh}
          user={user}
        />
      </div>
    </div>
  );
}
